export const blogRoutes = {
  ibanInvoiceInstruction: "post/iban-invoice-instruction",
};

export const blogURL = "https://blog.ibanoplata.com";
